import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'preact/hooks';

import Loader from '@/components/Loader';
import useEventsQuery from '@/hooks/useEventsQuery';

import UpcomingEventItem from './UpcomingEventItem';

const END_TIME = Date.parse('2099-12-31T00:00:00Z');

const UpcomingEventsCard = () => {
  const startTime = useMemo(() => Date.now(), []);
  const { data, isLoading } = useEventsQuery({
    startTime,
    endTime: END_TIME,
    pageSize: 3,
  });

  return (
    <div className="preflight rounded-lg px-4 shadow-1">
      <div className="flex justify-between pt-4">
        <h3 className="preflight preflight-h3">Upcoming Events</h3>
        <a href="/schedule" className="preflight preflight-a inline-flex items-center gap-1 text-xs text-grey-3">
          <span>See all</span>
          <FontAwesomeIcon icon={faChevronRight} />
        </a>
      </div>
      {isLoading ? (
        <Loader width="40px" height="40px" className="h-[360px]" />
      ) : (
        <ul className="preflight preflight-ul divide-y pb-1">
          {data?.map(
            ({
              _id,
              animal,
              businessHourId,
              habitatImage,
              habitatSlug,
              eventType,
              zooSlug,
              title,
              description,
              startTime,
              stopTime,
            }) => (
              <li key={_id} className="preflight">
                <UpcomingEventItem
                  _id={_id}
                  animal={animal}
                  businessHourId={businessHourId}
                  habitatImage={habitatImage}
                  habitatSlug={habitatSlug}
                  eventType={eventType}
                  zooSlug={zooSlug}
                  title={title}
                  description={description}
                  startTime={startTime}
                  stopTime={stopTime}
                />
              </li>
            ),
          )}
        </ul>
      )}
    </div>
  );
};

export default UpcomingEventsCard;
